const config = {
  appTitle: process.env.REACT_APP_TITLE || "Fintech Strategies",
  recaptchaKey: process.env.REACT_APP_RECAPTCHA_KEY
};

export default config;
